import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE --------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../../../Base/Components/Card/Card";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { getDateTimeStringSQL } from "../../../../../../Base/Services/Moment/Luxon";
import { getAreasAct } from "../../../../../../Base/API/Global/Areas/AreasRequests";
import { obtenerPrioridadesAct } from "../../../../../../Base/API/Global/Prioridades/PrioridadesRequests";
import { getLiberarRequisaMP, getLiberarRequisas } from "../../../../../../Base/API/IT/Accesos/AccesosRequests";
import { getListadoImagenes, mostrarImagenesProductos, } from "../../../../../../Base/API/IT/Imagenes/ImagenesRequest";

// ------------------- CONSULTAS A LA API ---------------------------
import {
  ObtenerSiguienteNoIngresoMateriale,
  ObtenerDetalleRequisa,
  ObtenerEncabezadoRequisa,
  EliminarItemIngreso,
  GuardarRequisaMaterial,
  EditarRequisaMaterial,
  ObtenerDetalleRequisaCRUD1,
  ObtenerSiguienteNoIngresoMP,
} from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";
import { getDetalleProductos } from "../../../../../../API/Global/ActivosFijos/DetalleProductosRequest";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import EncabezadoRequisasMateriales from "./EncabezadoRequisasMeteriales";
import RequisaOverlayPanelDetalle from "../OverlaysPanels/RequisaOverlayPanelDetalle";
import ActivosOverlayPanel from "../OverlaysPanels/ActivosOverlayPanel";

const RequisaMaterialCrud = ({
  idIngreso,
  setIngresoToShow,
  actualizarIngresosScreen,
  setOrdenDialog,
  habilitar,
  setHabilitar,
  item = null,
  MateriaPrima,
  editable=true,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [encabezado, setEncabezado] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [NoIngreso, setNoIngreso] = useState([]);
  const [agentes, setAgentes] = useState([]);
  const [areas, setareas] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [mostrarCarousel, setMostrarCarousel] = useState(true);
  const [botonReporteHabilitado, setBotonReporteHabilitado] = useState(false);

  const esMateriaPrima = MateriaPrima === true || MateriaPrima === 1;

  //   PARA ENCABEZADO EL VALUES
  const initialValues = {
    FechaEnc: new Date(),
    IdEstado: 28,
    StatusName: "Creado",
    IdIngreso: -1,
    Requisa: idIngreso ? idIngreso : "",
    Comentarios: "",
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  // OBTENER INFORMACION PARA LOS DROPDAWN
  const getInfo = async () => {
    setLoading(true);

    const agentesSolicita = await getLiberarRequisas();
    const ageentesMP = await getLiberarRequisaMP();

    if(esMateriaPrima){
      setAgentes(ageentesMP)
    }else{
      setAgentes(agentesSolicita);
    }

    const areasActivas = await getAreasAct();
    setareas(areasActivas);

    const prioridadesActivas = await obtenerPrioridadesAct("PurcharseRequest");
    setPrioridades(prioridadesActivas);

    setLoading(false);
  };

  // OBTENER VALORES INICIALES PARA CREAR UNA NUEVA REQUISA DE MATERIALES
  const getInfoNew = async () => {
    setLoading(true);
    const NIngreso = await ObtenerSiguienteNoIngresoMateriale();
    const NIngresoMP = await ObtenerSiguienteNoIngresoMP();

    if(esMateriaPrima){
      setNoIngreso(NIngresoMP)
    }else{
      setNoIngreso(NIngreso);
    }

    const NumIngreso = esMateriaPrima ? NIngresoMP[0].Requisa : NIngreso[0].Requisa

    const areasActivas = await getAreasAct();
    setareas(areasActivas);

    const prioridadesActivas = await obtenerPrioridadesAct("PurcharseRequest");
    setPrioridades(prioridadesActivas);


    const d = {
      ...values,
      IdRequisaEnc: -100,
      Requisa: NumIngreso,
      IdSolicita: item?.IdUsuarioSolicita ? item?.IdUsuarioSolicita : null,
      UserNameSolicita: item?.UserNameSolicita ? item?.UserNameSolicita : '',
      IdArea: item?.IdArea ? item?.IdArea : null,
      Area: item?.Area ? item?.Area : '',
      IdAsignacion: item?.IdAsignacion ? item?.IdAsignacion : null,
    };

    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  // OBTENER PARA EDITAR UNA REQUISA DE MATERIAL
  const obtenerIngreso = async (ingreso) => {
    setLoading(true);

    let req = ingreso ? ingreso : values;
    const det = await ObtenerDetalleRequisaCRUD1(req);
    setDetalles(det);
    const t = await ObtenerEncabezadoRequisa(req);

    setEncabezado(t);

    const agentesSolicita = await getLiberarRequisas();
    const ageentesMP = await getLiberarRequisaMP();
    
    if(esMateriaPrima){
      setAgentes(ageentesMP)
    }else{
      setAgentes(agentesSolicita);
    }

    if (t.length > 0) {
      setMostrarCarousel(true);
      const [detailIngresos] = t;
      const n = {
        ...detailIngresos,
        Requisa: detailIngresos.Requisa,
        FechaEnc: new Date(detailIngresos.FechaEnc),
        UserNameSolicita: esMateriaPrima ? ageentesMP.find((ac) => ac.IdUser === detailIngresos.IdSolicita) :  agentesSolicita.find((ac) => ac.IdUser === detailIngresos.IdSolicita),
      };

      setValues(n);
      setIngresoToShow(detailIngresos.Requisa);
      setHabilitar(false);
    } else {
      setMostrarCarousel(false);
      const d = {
        ...initialValues,
        Requisa: values.Requisa,
      };
      setValues(d);
      setDetalles([]);
      toastShow( toast, "error", "Error al obtener", "No se encontro la requisa.");
      setHabilitar(true);
    }
    setLoading(false);
  };

  // AGREGAR NUEVA FILA
  const agregarNuevaFila = () => {
    let newRowData = [...detalles];
    let IdDet = -(detalles?.length +   1)

    const newData = {
      IdRequisaDet: IdDet,
      CodigoProducto: "",
      NombreProducto: "",
      FechaDet: new Date(),
      IdEstado: 28,
      StatusName: "Creado",
      UnitName: "",
      Descripcion: "",
      Qty: 0,
      Quantity: "",
      IdProduct: "",
      IdUnit: "",
      IdActivo: esMateriaPrima ? null : item?.IdActivoFijo || null,
      NombreActivo: esMateriaPrima ? "" : item?.NombreActivo || "",
      CodigoActivo: esMateriaPrima ? "" : item?.CodigoActivo || "",
      Marca: "",
      Modelo: "",
    };

    if (newRowData.length > 0) {
      if (
        newRowData[newRowData.length - 1].IdProduct ||
        newRowData[newRowData.length - 1].IdRequisaDet
      ) {
        newRowData.push(newData);
      } else {
        newRowData[newRowData.length - 1] = newData;
      }
    } else {
      newRowData.push(newData);
    }
    setDetalles(newRowData);
  };

  // ACTUALIZAR INGRESOS
  const actualizarIngresos = async (NoIngreso) => {
    setLoading(true);
    const d = await ObtenerDetalleRequisa(
      NoIngreso ? NoIngreso : values.Requisa
    );
    setDetalles(d);
    setLoading(false);
  };

  // AGREGAR PRODUCTO
  const changePO = ({ data }) => {
    return (
      <RequisaOverlayPanelDetalle
        rowData={data}
        onChange={ async ({ api, data }, rowData) => {
          const index = detalles.findIndex( (detail) => detail.IdRequisaDet === rowData.IdRequisaDet);
          const isAlreadyAdded = detalles.some((detail) => detail.IdProducto === data.IdProduct || detail.IdProduct === data.IdProduct);

          if (isAlreadyAdded) {
            toastShow( toast, "warn", "Advertencia", "El producto seleccionado ya esta ingresado en esta requisa");
            return;
          }

          let newDetail = [...detalles];
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].IdProduct = data.IdProduct;
          newDetail[index].Descripcion = data.Descripcion;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].IdUnit = data.IdUnit;
          newDetail[index].UnitName = data.UnitName;
          newDetail[index].Quantity = data.Inventario;
          newDetail[index].IdIngresoDetalle = data.IdIngresoDetalle;
          newDetail[index].NombreCategoria = data.NombreCategoria;
          newDetail[index].NombreSubcategoria = data.NombreSubcategoria;
          newDetail[index].NombreTipoProducto = data.NombreTipoProducto;
          newDetail[index].IdTipoIngreso = data.IdTipoIngreso;
          setDetalles(newDetail);

          if (!esMateriaPrima) {
            const verificar = await verificarProducto(newDetail[index]);

            if (!verificar) {
              toastShow(
                toast,
                "warn",
                "Advertencia",
                "El producto seleccionado no puede ser agregado al activo.",
              );

              let newDetail2 = [...detalles];

              newDetail2[index].CodigoProducto = "";
              newDetail2[index].IdProduct = "";
              newDetail2[index].Descripcion = "";
              newDetail2[index].NombreProducto = "";
              newDetail2[index].IdUnit = "";
              newDetail2[index].UnitName = "";
              newDetail2[index].Quantity = "";
              newDetail2[index].IdIngresoDetalle = "";
              newDetail2[index].NombreCategoria = "";
              newDetail2[index].NombreSubcategoria = "";
              newDetail2[index].NombreTipoProducto = "";
              newDetail2[index].IdTipoIngreso = [];

              setDetalles(newDetail2);
            }
          }
          api.stopEditing();
        }}
        MateriaPrima={MateriaPrima}
      />
    );
  };

  // AGREGAR ACTIVO
  const changeActivo = ({ data }) => {
    return (
      <ActivosOverlayPanel
        rowData={data}
        onChange={async({ api, data }, rowData) => {
          const index = detalles.findIndex((detail) => detail.IdRequisaDet === rowData.IdRequisaDet);

          let newDetail = [...detalles];
          newDetail[index].IdActivo = data.IdActivo;
          newDetail[index].IdActivoPadre = data.IdActivoPadre;
          newDetail[index].NombreActivo = data.NombreActivo;
          newDetail[index].CodigoActivo = data.CodigoActivo;
          newDetail[index].Marca = data.Marca;
          newDetail[index].Modelo = data.Modelo;
          setDetalles(newDetail);         

          const verificar = await verificarProducto(newDetail[index])
          if(!verificar){
            toastShow(toast, 'warn', 'Adverencia', 'El producto selecionado no puede ser agregado al activo.')
            let newDetail2 = [...detalles];
            newDetail2[index].IdActivo = '';
            newDetail2[index].IdActivoPadre = '';
            newDetail2[index].NombreActivo = '';
            newDetail2[index].CodigoActivo = '';
            newDetail2[index].Marca = '';
            newDetail2[index].Modelo = '';
            setDetalles(newDetail2)
          }
          api.stopEditing();
        }}
        />
    );
  };

  const addOC = (infoOrden) => {
    let OrdenExistente = false;

    // Verificar si algún detalle de infoOrden ya existe en detalles
    infoOrden.forEach((orden) => {
      if (detalles.some((detalle) => detalle.IdProducto === orden.IdProduct || detalle.IdProduct === orden.IdProduct)) {
        OrdenExistente = true;
      }
    });

    if (OrdenExistente) {
      toastShow( toast, "warn", "Advertencia", "No se permiten valores repetidos en la tabla");
    } else {

      // Agregar los detalles solo si no existen en la tabla
      let dataNueva = [];
      infoOrden.forEach((orden) => {
        let IdDet = (detalles.length + dataNueva.length + 1) * -1;
        dataNueva.push({
          IdRequisaDet: IdDet,
          IdIngresoDetalle: orden.IdIngresoDetalle,
          CodigoProducto: orden.CodigoProducto,
          NombreProducto: orden.NombreProducto,
          FechaDet: new Date(),
          IdEstado: values.IdEstado,
          StatusName: values.StatusName,
          UnitName: orden.UnitName,
          Descripcion: orden.Descripcion,
          Qty: 0,
          Quantity: esMateriaPrima? orden.InventarioPacas: orden.Inventario,
          IdProduct: orden.IdProduct,
          IdUnit: orden.IdUnit,
          NombreCategoria: orden.NombreCategoria,
          NombreTipoProducto: orden.NombreTipoProducto,
          NombreSubcategoria: orden.NombreSubcategoria,
          IdTipoIngreso: orden.IdTipoIngreso,
          IdActivo: esMateriaPrima ? null : item?.IdActivoFijo || null,
          NombreActivo: esMateriaPrima ? "" : item?.NombreActivo || "",
          CodigoActivo: esMateriaPrima ? "" : item?.CodigoActivo || "",
        });
      });

      let nuevoArreglo = [...detalles, ...dataNueva];
      setDetalles(nuevoArreglo);
    }
  };

  // GUARDAR O EDITAR INGRESOS
  const guardarRequisaMaterial = async () => {
    let guardar = true;
  
    if (detalles.length === 0) {
      toastShow( toast, "error", "Error al guardar", "Debe seleccionar al menos un Producto.");
      guardar = false;
    } else {
      const tieneErrores = detalles.some((d) => {
        if (d.IdProduct === "") {
          toastShow( toast, "error", "Error al guardar", "Todos los items deben contener un Producto.");
          return true;
        }
        // if ((d.IdActivo === "" || !d?.IdActivo) && (MateriaPrima === 1)) {
        //   toastShow( toast, "error", "Error al guardar", "Todos los items deben contener un Activo.");
        //   return true;
        // }
        if (d.Qty === 0) {
          toastShow( toast, "warn", "Advertencia", "Cantidad Solicitada no puede ser 0.");
          return true;
        }
        if (!d.Comentarios) {
          toastShow( toast, "warn", "Advertencia", "Todos los items deben contener un Comentario.");
          return true;
        }
        return false;
      });
  
      if (tieneErrores) {
        guardar = false;
      }
    }
  
    if (guardar) {
      setLoading(true);
      setHabilitar(true);

      const encabezado = {
        IdRequisaEnc: values.IdRequisaEnc,
        Requisa: values.Requisa,
        FechaEnc: getDateTimeStringSQL(new Date(values.FechaEnc)),
        Comentarios: values.Comentarios,
        IdArea: values.Area.IdArea || values.IdArea,
        IdSolicita: values.UserNameSolicita?.IdUser || values?.IdSolicita,
        IdPrioridad: values.Priority.IdPriority || values.IdPrioridad,
        IdTecnico: 1,
        IdUserEdit: userAuth.IdUser,
        IdEstado: values.IdEstado,
        IdUserCreate: values.IdUserCreate || userAuth.IdUser,
        IdAsignacion: item?.IdAsignacion,
        MateriaPrima: esMateriaPrima ? true : null,
        IdOrdenTrabajoDet: item?.IdOrdenDeTrabajoDet ? item?.IdOrdenDeTrabajoDet : null,
        IdOrdenTrabajoEnc: item?.IdOrdenDeTrabajo ? item?.IdOrdenDeTrabajo : null,
      };
  
      const detallesIngreso = detalles.map((detalle) => ({
        ...detalle[0],
        IdRequisaDet: detalle.IdRequisaDet,
        IdRequisaEnc: values.IdRequisaEnc,
        FechaDet: getDateTimeStringSQL(new Date(detalle.FechaDet)),
        Qty: detalle.Qty,
        IdUnit: detalle.IdUnit,
        IdProducto: detalle.IdProducto || detalle.IdProduct,
        Idtecnico: 1,
        IdUserEdit: userAuth.IdUser,
        IdEstado: detalle.IdEstado,
        Comentarios: detalle.Comentarios,
        IdActivo: detalle.IdActivo,
      }));

      if (values.IdRequisaEnc > 0) {
        const respuestaDetalles = await EditarRequisaMaterial(encabezado, detallesIngreso );
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow( toast, "success", "Editada", respuestaDetalles[0].MENSAJE
          );
          setBotonReporteHabilitado(true);
          actualizarIngresos();
          actualizarIngresosScreen();
          setLoading(false);
        } else {
          toastShow( toast, "error", "Error al editar", respuestaDetalles[0].MENSAJE
          );
          setLoading(false);
        }
      } else {
        const respuestaDetalles = await GuardarRequisaMaterial(encabezado,detallesIngreso);
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow( toast, "success", "Guardado", respuestaDetalles[0].MENSAJE);
          actualizarIngresos(respuestaDetalles[0]?.Requisa);
          obtenerIngreso(respuestaDetalles[0]?.Requisa);
          actualizarIngresosScreen();
          setBotonReporteHabilitado(true);
          setLoading(false);
        } else {
          toastShow( toast, "error", "Error al guardar", respuestaDetalles[0].MENSAJE);
          setLoading(false);
        }
      }
    } else {
      setLoading(false);
    }
  }; 

  // ELIMINAR ITEM
  const eliminarItemDetalle = () => {
    if (selected.length > 0) {
      const algunDetalleNoValido = selected.some((detalle) => detalle?.IdEstado !== 29);
      const Id = selected.some((detalle) => detalle?.IdRequisaDet > 0);

      if (algunDetalleNoValido && Id > 0) {
        toastShow( toast, "error", "Error", "No se puede eliminar, ya existe una salida de este detalle de Requisa.");
      } else {
        confirmDialog({
          message: "Esta seguro que desea eliminar este item",
          header: "Cancelar",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Si",
          accept: () => cancelarDetalle(2),
          rejectLabel: "No",
          style: { backgroundColor: "white" },
        });
        // setVisible(true);
      }
    } else {
      toastShow( toast, "warn", "Advertencia", "Seleccione un detalle de requisa.");
    }
  };

  // ELIMINAR ITEM
  const cancelarDetalle = async () => {
    let tempo = [...detalles];
    selected.forEach((select) => {
      const index = tempo.findIndex(
        (detail) => detail.IdProduct === select.IdProduct
      );
      if (index >= 0) {
        tempo.splice(index, 1); // Elimina el elemento del arreglo
      }
    });

    const detallesIngreso = selected.map((detalle) => ({
      ...detalle[0],
      IdRequisaDet: detalle.IdRequisaDet,
      IdUserCancela: userAuth.IdUser,
    }));

    setDetalles(tempo); // Actualiza el estado con el nuevo arreglo sin el elemento eliminado

    const eliminados = await EliminarItemIngreso(detallesIngreso);

    if (eliminados[0]?.ESTADO !== -1) {
      setLoading(true);
      toastShow(toast, "success", "Eliminado", eliminados[0]?.MENSAJE);
      actualizarIngresosScreen();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      actualizarIngresosScreen();
    } else {
      toastShow(toast, "error", "Error al eliminar", eliminados[0]?.MENSAJE);
    }
  };

  // AGREGAR COMENTARIO PARA UN DETALLE DE INGRESO REQUISA
  const changeComentario = ({ data, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
    );
    let newDetail = [...detalles];
    if (column.field === "Comentario") {
      newDetail[index].Comentarios = data.Comentario;
    }
    setDetalles(newDetail);
  };

  // AGREGAR CANTIDAD PARA UN DETALLE DE INGRESO REQUISA
  const changeCantidad = ({ data, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
    );

    let newDetail = [...detalles];

    // Si la cantidad en inventario es cero, permitir agregar cualquier cantidad
    if (data.Quantity === 0) {
      if (column.field === "Qty") {
        newDetail[index].Qty = data.Qty;
        setDetalles(newDetail);
      }
      return;
    }

    if (newDetail[index].Qty > data.Quantity) {
      toastShow( toast, "warn", "Advertencia", "La cantidad ingresada no debe ser mayor que el inventario.");
      newDetail[index].Qty = 0;
      setDetalles(newDetail);
      return;
    } else {
      if (column.field === "Qty") {
        newDetail[index].Qty = data.Qty;
        setDetalles(newDetail);
      }
    }
  };

  const verificarProducto = async (item) => {
    let IdProduct = item?.IdProduct
    let IdActivo = item?.IdActivo
    let IdActivoPadre = item?.IdActivoPadre
    if(IdProduct && IdActivo){

      const detalleP = await getDetalleProductos();

      let IdIncludes = detalleP.map(i => i?.IdProducto)
      
      if(IdIncludes.includes(IdProduct)){
        const filterDetalle = detalleP.filter((i) => i.IdActivo === IdActivo || i?.IdActivo === IdActivoPadre);
        let IdIncludes1 = filterDetalle.map(i => i?.IdProducto)
        if(IdIncludes1.includes(IdProduct)){
          return true
        }else{
          return false
        }
      }else{
        return true
      }
    }else{
      return true
    }


  }

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdRequisaDet",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "medium",
      editable: habilitar,
      // cellEditor: changeEstado,
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData?.IdEstado,
        Estado: rowData?.StatusName,
      }),
    },
    {
      header: "Código Producto",
      headerEn: "Purchase Order",
      field: "CodigoProducto",
      className: "Xsmall",
      frozen: true,
      editable: (data) => {
        if(habilitar){
          if (data.data.IdEstado !== 29 && data.data?.IdRequisaDet > 0) {
            return false; 
          } else {
            return true; 
          }
        }else{
          return false
        }
      },
      cellEditor: changePO,
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "Xlarge",
      frozen: true,
    },
    {
      header: "Descripción",
      headerEn: "Product",
      field: "Descripcion",
      minWidth: 400,
      flex: 1,
      className: "XXlarge",
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "small",
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "small",
    },
    {
      header: "Sub Categoría",
      headerEn: "Sub Category",
      field: "NombreTipoProducto",
      className: "small",
    },
    {
      header: "Unidad",
      headerEn: "Product",
      field: "UnitName",
      className: "Xsmall",
    },
    {
      header: "Código Activo",
      headerEn: "Active Code",
      field: "CodigoActivo",
      className: "Xsmall",
      hidden: !esMateriaPrima,
    },
    {
      header: "Activo",
      headerEn: "Active",
      field: "NombreActivo",
      className: "Xlarge",
      hidden: !esMateriaPrima,
      editable: (data) => {
        if(habilitar){
          if (data.data.IdEstado !== 29 && data.data?.IdRequisaDet > 0) {
            return false; 
          } else {
            return true; 
          }
        }else{
          return false
        }
      },
      cellEditor: changeActivo,
    },
    {
      header: "Marca",
      headerEn: "Brand",
      field: "Marca",
      className: "small",
      hidden: !esMateriaPrima,
    },
    {
      header: "Modelo",
      headerEn: "Model",
      field: "Modelo",
      className: "small",
      hidden: !esMateriaPrima,
    },
    {
      header: "Inventario",
      headerEn: "Product",
      field: "Quantity",
      Format: "Currency",
      Sumary: "sum",
      className: "small",
      frozen: true,
      alignFrozen: "right",
    },
    {
      header: "Cant. Solicitada",
      headerEn: "Cant. Solicitada",
      field: "Qty",
      Format: "Currency",
      Sumary: "sum",
      className: "small",
      alignFrozen: "right",
      frozen: true,
      editable: (data) => {
        if(habilitar){
          if (data.data.IdEstado !== 29 && data.data?.IdRequisaDet > 0) {
            return false; 
          } else {
            return true; 
          }
        }else{
          return false
        }
      },
      onChange: (data) => changeCantidad(data),
    },
    {
      header: "Comentario",
      headerEn: "Product",
      field: "Comentarios",
      className: "colum-width-Xlarge",
      frozen: true,
      alignFrozen: "right",
      editable: (data) => {
        if(habilitar){
          if (data.data.IdEstado !== 29 && data.data?.IdRequisaDet > 0) {
            return false; 
          } else {
            return true; 
          }
        }else{
          return false
        }
      },
      onChange: (data) => changeComentario(data),
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => showModal(e),
    onCellFocused: (e, a) => {
      if (!e.rowPinned) {
        getImagenes(a[e.rowIndex].data);
      }
    },
  };

  const getImagenes = async (productos) => {
    if (imagenes?.CodigoProducto !== productos?.CodigoProducto) {
      const i = await getListadoImagenes(productos?.CodigoProducto);
      if (i?.length > 0) {
        let n = await Promise.all(
          i.map(async (e) => {
            try {
              const a = await mostrarImagenesProductos(
                productos?.CodigoProducto,
                e
              );
              return a;
            } catch (e) {
              return e;
            }
          })
        );
        setImagenes({ CodigoProducto: productos?.CodigoProducto, img: n, NombreProducto: productos?.NombreProducto });
      } else {
        setImagenes([]);
      }
    }

    // setImagenes(i);
  };

  const showModal = () => {
    setOrdenDialog(true);
  };

  useEffect(() => {
    if (idIngreso) {
      obtenerIngreso(idIngreso);
      setBotonReporteHabilitado(true);
    } else {
      getInfo();
      getInfoNew();
      setBotonReporteHabilitado(false);
    }
  }, []);

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoRequisasMateriales
        values={values}
        handleInputChange={handleInputChange}
        handleChange={handleChange}
        setHabilitar={setHabilitar}
        toast={toast}
        resetForm={resetForm}
        detalles={detalles}
        setDetalles={setDetalles}
        getIngreso={obtenerIngreso}
        habilitar={habilitar}
        setValues={setValues}
        setIngresoToShow={setIngresoToShow}
        agentes={agentes}
        areas={areas}
        prioridades={prioridades}
        agregarNuevaFila={agregarNuevaFila}
        eliminarItemDetalle={eliminarItemDetalle}
        guardarRequisa={guardarRequisaMaterial}
        addOC={addOC}
        imagenes={imagenes}
        setMostrarCarousel={setMostrarCarousel}
        mostrarCarousel={mostrarCarousel}
        setBotonReporteHabilitado={setBotonReporteHabilitado}
        botonReporteHabilitado={botonReporteHabilitado}
        MateriaPrima={MateriaPrima}
        editable={editable}
      ></EncabezadoRequisasMateriales>
      <Card
        contenido={
          <div style={{ height: "60vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
    </div>
  );
};

export default RequisaMaterialCrud;
